import React, { createContext, useState, useEffect, useContext } from "react";
import { QuerySnapshot, collection, getDocs, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { AuthContext } from "./AuthContext";

const AppContext = createContext();

const AppProvider = ({ children }) => {
    const { currentUser } = useContext(AuthContext)
    const [dataProjects, setDataProjects] = useState([]);
    const [establishmentList, setEstablishmentList] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [pmeList, setPmeList] = useState([]);
    const [requestsList, setRequestsList] = useState([]);
    const [notificationsList, setNotificationsList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [dataSearch, setDataSearch] = useState({
        region: null,
        commune: null,
        holder: { value: null, id: null },
        establishment: { value: null, id: null },
    });
    const [globalNotifications, setGlobalNotifications] = useState({
        userAdded: false,
        userEdited: false,
        addUpdatedPME: false,
        addRequest: false,
        addPaymentRequest: false
    });
    const [viewPayment, setViewPayment] = useState(false);
    const [viewObservedPayment, setViewObservedPayment] = useState(false);
    const [viewRejectedPayment, setViewRejectedPayment] = useState(false);
    const [selectedRequestPayment, setSelectedRequestPayment] = useState(null);
    const [dataPaymentRequest, setDataPaymentRequest] = useState({
        region: null,
        commune: null,
        holder: { value: null, id: null },
        establishment: { value: null, id: null }
    });

    const createSubscription = (collectionName, setState) => {
        return onSnapshot(
            collection(db, collectionName),
            (querySnapshot) => {
                const data = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setState(data);
            },
            (error) => {
                console.error(`Error fetching ${collectionName}:`, error);
            }
        );
    };

    useEffect(() => {
        if (currentUser) {
            const unsubscribeProjects = createSubscription("projects", setDataProjects);
            const unsubscribeEstablishments = createSubscription("establishments", setEstablishmentList);
            const unsubscribeUsers = createSubscription("users", setUsersList);
            const unsubscribePme = createSubscription("pme", setPmeList);
            const unsubscribeRequests = createSubscription("requests", setRequestsList);
            // const unsubscribeNotifications = createSubscription("notifications", setNotificationsList);

            // Indicar que la carga de datos ha terminado
            setIsLoading(false);

            return () => {
                unsubscribeProjects();
                unsubscribeEstablishments();
                unsubscribeUsers();
                unsubscribePme();
                unsubscribeRequests();
                // unsubscribeNotifications();
            };
        }
    }, [currentUser]);

    // useEffect(() => {
    //     if (currentUser) {
    //         const unsubscribeProjects = onSnapshot(
    //             collection(db, "projects"),
    //             (querySnapshot) => {
    //                 const dataArray = querySnapshot.docs.map((doc) => ({
    //                     id: doc.id,
    //                     ...doc.data(),
    //                 }));
    //                 setDataProjects(dataArray);
    //                 setIsLoading(false);
    //             },
    //             (error) => {
    //                 console.error("Error fetching data:", error);
    //                 setIsLoading(false);
    //             }
    //         );

    //         const unsubscribeEstablishments = onSnapshot(
    //             collection(db, "establishments"),
    //             (querySnapshot) => {
    //                 const establishments = querySnapshot.docs.map((doc) => ({
    //                     id: doc.id,
    //                     ...doc.data(),
    //                 }));
    //                 setEstablishmentList(establishments);
    //             },
    //             (error) => {
    //                 console.error("Error fetching establishments:", error);
    //             }
    //         );

    //         const unsubscribeUsers = onSnapshot(
    //             collection(db, "users"),
    //             (querySnapshot) => {
    //                 const users = querySnapshot.docs.map((doc) => ({
    //                     id: doc.id,
    //                     ...doc.data(),
    //                 }));
    //                 setUsersList(users);
    //             },
    //             (error) => {
    //                 console.error("Error fetching users:", error);
    //             }
    //         );

    //         const unsubscribePme = onSnapshot(
    //             collection(db, "pme"),
    //             (querySnapshot) => {
    //                 const pmes = querySnapshot.docs.map((doc) => ({
    //                     id: doc.id,
    //                     ...doc.data(),
    //                 }));
    //                 setPmeList(pmes);
    //             },
    //             (error) => {
    //                 console.error("Error fetching PMEs:", error);
    //             }
    //         );

    //         const unsubscribeRequests = onSnapshot(
    //             collection(db, "requests"),
    //             (querySnapshot) => {
    //                 const requests = querySnapshot.docs.map((doc) => ({
    //                     id: doc.id,
    //                     ...doc.data(),
    //                 }));
    //                 setRequestsList(requests);
    //             },
    //             (error) => {
    //                 console.error("Error fetching requests:", error);
    //             }
    //         );

    //         const unsubscribeNotifications = onSnapshot(
    //             collection(db, "notifications"),
    //             (querySnapshot) => {
    //                 const notifications = querySnapshot.docs.map((doc) => ({
    //                     id: doc.id,
    //                     ...doc.data(),
    //                 }));
    //                 setNotificationsList(notifications);
    //             },
    //             (error) => {
    //                 console.error("Error fetching notifications:", error);
    //             }
    //         );

    //         return () => {
    //             unsubscribeProjects()
    //             unsubscribeEstablishments();
    //             unsubscribeUsers();
    //             unsubscribePme();
    //             unsubscribeRequests();
    //             unsubscribeNotifications();
    //         };
    //     }
    // }, [currentUser]);

    const showNotification = (type, value) => {
        setGlobalNotifications(prev => ({
            ...prev,
            [type]: value
        }));

        if (value) {
            setTimeout(() => {
                setGlobalNotifications(prev => ({
                    ...prev,
                    [type]: false
                }));
            }, 3000);
        }
    };

    return (
        <AppContext.Provider value={{ dataProjects, isLoading, establishmentList, usersList, pmeList, requestsList, dataSearch, setDataSearch, notificationsList, globalNotifications, showNotification, viewPayment, setViewPayment, viewObservedPayment, setViewObservedPayment, viewRejectedPayment, setViewRejectedPayment, dataPaymentRequest, setDataPaymentRequest, selectedRequestPayment, setSelectedRequestPayment }}>
            {children}
        </AppContext.Provider>
    );
};

export { AppContext, AppProvider }